import {
  IonContent,
  IonPage,
  IonToolbar,
  IonTitle,
  IonButtons,
  IonBackButton,
  IonSpinner,
  IonText,
} from '@ionic/react';
import { useParams } from 'react-router-dom';
import { useIonRouter } from '@ionic/react';
import { useQuery } from '@apollo/client/react';
import { GET_CHANNEL } from '../../../graphql/queries/channel';
import type { GetChannelQuery, GetChannelQueryVariables } from '../../../types/graphql-generated';
import { AppSectionHeader } from '../../components/ui/AppSectionHeader';
import { ChannelHeaderInfo } from './components/ChannelHeaderInfo';
import { ChannelPostList } from './components/ChannelPostList';
import { ChannelPostsPanel } from './components/ChannelPostsPanel';
import { WritePostFab } from './components/WritePostFab';

interface ViewChannelProps {
  defaultBackHref?: string;
}

// The public page for a single channel: its identity block (name, description,
// followers + action) and its published posts.
export const ViewChannel: React.FC<ViewChannelProps> = ({
  defaultBackHref = '/app/main/channels',
}) => {
  const channelId = useParams<'channelId'>().channelId!;
  const ionRouter = useIonRouter();

  const { data, loading } = useQuery<GetChannelQuery, GetChannelQueryVariables>(GET_CHANNEL, {
    variables: { id: channelId },
  });

  const channel = data?.channel;

  return (
    <IonPage>
      <AppSectionHeader variant="main">
        <IonToolbar>
          <IonButtons slot="start">
            <IonBackButton defaultHref={defaultBackHref} />
          </IonButtons>
          <IonTitle className="ml-4">{channel?.name ?? 'Canal'}</IonTitle>
        </IonToolbar>
      </AppSectionHeader>

      <IonContent className="ion-padding">
        {loading && !channel && (
          <div className="flex justify-center items-center min-h-[200px]">
            <IonSpinner name="crescent" />
          </div>
        )}

        {!loading && !channel && (
          <div className="flex justify-center items-center min-h-[200px]">
            <IonText color="medium">
              <p>No se ha encontrado el canal.</p>
            </IonText>
          </div>
        )}

        {channel && (
          <>
            <ChannelHeaderInfo channel={channel} />
            {channel.viewerIsOwner ? (
              <ChannelPostsPanel channelId={channel.id} />
            ) : (
              <ChannelPostList channelId={channel.id} />
            )}
          </>
        )}

        {channel?.viewerIsOwner && (
          <WritePostFab
            onClick={() => ionRouter.push(`/app/main/channels/${channel.id}/publicar`)}
          />
        )}
      </IonContent>
    </IonPage>
  );
};
